.wrapper {
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 1rem;
  background-color: #fff;

  thead {
    tr {
      border: 1px solid #e9ecef;
    }

    th {
      padding: 6px;
      padding-left: 16px;
      background-color: #f8f9fa;
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid #e9ecef;

      td {
        padding: 6px;
        padding-left: 16px;

        &:first-child {
          border-left: 1px solid #e9ecef;
        }

        &:last-child {
          border-right: 1px solid #e9ecef;
        }
      }

      &:last-child {
        td {
          border-bottom: 1px solid #e9ecef;
        }
      }
    }

    td {
      padding: 4px;
      border-top: 1px solid #e9ecef;
    }
  }

  .center {
    display: flex;
    justify-content: center;
  }
}
